"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringExt = void 0;
var StringUtil_1 = require("@aelesia/commons/dist/src/collections/util/StringUtil");
var TimeUtil_1 = require("@aelesia/commons/dist/src/collections/util/TimeUtil");
var RandomUtil_1 = require("@aelesia/commons/dist/src/collections/util/RandomUtil");
function StringExt() {
    String.prototype.isNum = function () {
        return StringUtil_1.StringUtil.isNum(this.toString());
    };
    String.prototype.isBlank = function () {
        return StringUtil_1.StringUtil.isBlank(this.toString());
    };
    String.prototype.replaceAll = function (search, replacement) {
        return StringUtil_1.StringUtil.replaceAll(this.toString(), search, replacement);
    };
    String.prototype.remove = function (char) {
        return StringUtil_1.StringUtil.remove(this.toString(), char);
    };
    String.prototype._num = function () {
        return StringUtil_1.StringUtil._num(this.toString());
    };
    String.prototype._json = function () {
        return StringUtil_1.StringUtil._json(this.toString());
    };
    String.prototype.secs = function () {
        return TimeUtil_1.TimeUtil.secs(StringUtil_1.StringUtil._num(this.toString()));
    };
    String.prototype.mins = function () {
        return TimeUtil_1.TimeUtil.mins(StringUtil_1.StringUtil._num(this.toString()));
    };
    String.prototype.hours = function () {
        return TimeUtil_1.TimeUtil.hours(StringUtil_1.StringUtil._num(this.toString()));
    };
    String.prototype.days = function () {
        return TimeUtil_1.TimeUtil.days(StringUtil_1.StringUtil._num(this.toString()));
    };
    String.prototype.chance = function () {
        var num = this.substring(0, this.length - 1)._num();
        if (this[this.length - 1] !== '%' || num < 0 || num > 100) {
            throw new TypeError("StringUtil: You must provide a valid percentage between 0% to 100%");
        }
        return RandomUtil_1.RandomUtil.chance(num);
    };
}
exports.StringExt = StringExt;
//# sourceMappingURL=StringExt.js.map